// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"6ccdf6bb","359":"72b4eaf0","361":"c272f927"}[chunkId] + ".chunk.js";
};